module.exports = __webpack_public_path__ + "assets/f2e3d1a56594f9f0c40dfb1cdae696d8.svg";